<template>
  <div>
    <div class="email-edit-container">
      <div
        class="email-template-section"
        v-for="(template, index) in updatedTemplates"
        :key="template.title"
      >
        <div class="title-with-info">
          <h3>{{ template.title }}</h3>
          <hilo-button
            v-if="isAdmin"
            :label="
              template.showVariables ? 'Hide Variables ▲' : 'Show Variables ▼'
            "
            @click="toggleVariables(index)"
          />
          <div v-if="isAdmin && template.showVariables" class="tooltip">
            <ul>
              <li v-for="variable in template.variables" :key="variable">
                {{ variable }}
              </li>
            </ul>
          </div>
        </div>
        <div class="subject-input-container">
          <span class="subject-label">Subject: </span>
          <input
            type="text"
            v-model="template.subject"
            class="subject-input-box"
            :readonly="!isAdmin"
            :class="{ 'readonly-textarea': !isAdmin }"
          />
        </div>
        <textarea
          v-model="template.body"
          class="email-template-textbox"
          :readonly="!isAdmin"
          :class="{ 'readonly-textarea': !isAdmin }"
        ></textarea>
      </div>
    </div>
    <hilo-button
      v-if="isAdmin"
      styleType="submit"
      label="Save"
      @click="saveTemplates"
      style="margin-top: 10px"
    />
  </div>
</template>

<script>
import HiloButton from "src/components/HiloComponents/HiloButton.vue";
import { useLoginStore } from "@/stores/loginStore";

export default {
  components: {
    HiloButton,
  },
  props: {
    templates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      updatedTemplates: this.templates.map((template) => ({
        ...template,
        showVariables: false,
      })),
    };
  },
  computed: {
    isAdmin() {
      return useLoginStore().isAdmin;
    },
  },
  methods: {
    toggleVariables(index) {
      this.$set(this.updatedTemplates, index, {
        ...this.updatedTemplates[index],
        showVariables: !this.updatedTemplates[index].showVariables,
      });
    },
    saveTemplates() {
      this.$emit("save-templates", this.updatedTemplates);
    },
  },
};
</script>

<style scoped>
.subject-input-container {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.subject-label {
  margin-right: 10px;
  font-size: 14px;
}

.subject-input-box {
  width: 100%;
  padding: 2px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: #f4f4f4;
}

.email-edit-container {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.email-template-section {
  width: 49%;
}

.email-template-textbox {
  width: 100%;
  height: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: #f4f4f4;
}

.readonly-textarea {
  color: #888;
}

.title-with-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.tooltip {
  position: absolute;
  top: 50px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: max-content;
  display: block;
  white-space: nowrap;
  opacity: 1;
}

.tooltip ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.tooltip li {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}
</style>
